import React, { useMemo } from 'react'
import { Icon } from 'src/components'
import ModalBody from 'src/components/Modal/body'
import { faClose } from '@fortawesome/pro-light-svg-icons/faClose'
import i18n from 'src/i18n'
import ModalFooter from 'src/components/Modal/footer'
import Button from '@hotmart/space-lib/dist/components/button'
import ModalHeader from 'src/components/Modal/header'
import { CustomInput, CustomModal, RemoveButton } from './linkEditorModal.styles'
import { LinkEditorModalProps } from './linkEditorModal.types'
import { INPUT_PLACEHOLDER } from './linkEditorModal.constants'

const LinkEditorModal: React.FC<LinkEditorModalProps> = ({
  show,
  url,
  onClose,
  onChangeUrl,
  onSaveLink,
  onRemoveLink
}) => {
  const isValidUrl = useMemo(() => /^(\S+):(\/\/)?\S+$/.test(url), [url])

  return (
    <CustomModal show={show} onClose={onClose}>
      <ModalHeader className="_pb-0">
        <div
          data-test="container-modal-block-comments"
          className="_d-flex _align-items-center _justify-content-between"
        >
          <h2 className="_text-1 _text-gray-900 _font-weight-bold">
            {i18n.t('modal_edit_link.url')}
          </h2>

          <button
            className="_d-flex _cursor-pointer _border-0 _bg-transparent _mb-2"
            onClick={onClose}
            data-test="close-modal"
          >
            <Icon height={20} width={20} icon={faClose} className="_text-gray-700" />
          </button>
        </div>
      </ModalHeader>
      <ModalBody className="_py-0">
        <CustomInput
          type="url"
          label=""
          placeholder={INPUT_PLACEHOLDER}
          value={url || ''}
          autoFocus
          onChange={onChangeUrl}
        />
      </ModalBody>
      <ModalFooter className="_d-flex _justify-content-end _px-4 _pb-4 _pt-2">
        <RemoveButton size="sm" variation="danger" className="_border-0" onClick={onRemoveLink}>
          <p className="_font-weight _text-2 _mb-0">{i18n.t('buttons.remove_link')}</p>
        </RemoveButton>

        <Button
          size="sm"
          variation="primary"
          className="_border-0 _ml-3"
          disabled={!isValidUrl}
          onClick={onSaveLink}
        >
          <p className="_font-weight _text-2 _mb-0">
            {i18n.t('forms.schedule_posts.date_picker.buttons.apply')}
          </p>
        </Button>
      </ModalFooter>
    </CustomModal>
  )
}

export default LinkEditorModal
